<template>
  <v-main>
    <v-container fluid grid-list-xs>
      <v-layout row wrap justify-center align-center pb-3>
        <v-flex xs11 lg5>
          <h2>
            <v-icon @click="Fn_BackIndex" color="#077893" size="38"
              >mdi-chevron-left</v-icon
            >{{ _ฺBotOnePlatformQrcodeName }}
          </h2>
        </v-flex>
        <v-flex xs11 lg6 class="text-end"> </v-flex>
      </v-layout>
      <!-- <v-layout row wrap justify-center align-center pt-3 pb-3>
        <v-flex xs11 lg11>
          <v-card class="rounded-lg pb-2">
            <EmployeeOneID />
          </v-card>
        </v-flex>
      </v-layout> -->
      <!-- <v-layout row wrap justify-center align-center pt-3 pb-3>
        <v-flex xs11 lg11>
          <v-card>
            <v-flex lg12>
              <v-data-table
                :search="Search"
                :loading="tableload"
                :loading-text="$t('overlay.load')"
                :headers="headers"
                :items="AllService"
                :page.sync="page"
                :items-per-page="itemsPerPage"
                hide-default-footer
                @page-count="pageCount = $event"
              >
                <template v-slot:[`item.Type`]="{ item }">
                  <div v-if="item.Type === 'Group'">
                    {{ $t("dashboard.groupType") }}
                  </div>
                  <div v-else-if="item.Type === 'General'">
                    {{ $t("dashboard.generalType") }}
                  </div>
                </template>
                <template v-slot:[`item.NameTh`]="{ item }">
                  <div v-if="$t('default') === 'th'">
                    {{ item.NameTh }}
                  </div>
                  <div v-else>{{ item.NameEng }}</div>
                </template>
                <template v-slot:[`item.UpdatdeAt`]="{ item }">
                  <div v-if="$t('default') === 'th'">
                    {{ item.UpdatdeAt }}
                  </div>
                  <div v-else>
                    {{ item.UpdatdeAtEng }}
                  </div>
                </template>
                <template v-slot:[`item.action`]="{ item }">
                  <v-btn color="#077893" outlined @click="Fn_Detail(item)">{{
                    $t("consentlist.detail")
                  }}</v-btn>
                </template>
              </v-data-table>
            </v-flex>
            <v-flex xs12 sm12 md12 lg12>
              <div class="text-center pt-2">
                <v-pagination
                  :total-visible="7"
                  class="pt-2 pb-2"
                  circle
                  color="#077893"
                  v-model="page"
                  :length="pageCount"
                  prev-icon="mdi-menu-left"
                  next-icon="mdi-menu-right"
                >
                </v-pagination>
              </div>
            </v-flex>
          </v-card>
        </v-flex>
      </v-layout> -->

      <!-- <SearchConsentLogOnechatIndex /> -->
      <BotOnePlatformGroupSendDetail @loaded="onChildLoaded('group')" />
      <SendBotOnePlatFormDetail @loaded="onChildLoaded('detail')" />
      <!-- <SendOnechatDetail /> -->

      <!-- <LogOnechat /> -->
    </v-container>
    <div v-if="isLoading">
      <OverlaySearch />
    </div>
  </v-main>
</template>

<script>
import EmployeeOneID from "@/views/Admin/Consent/OnePlatform/EmployeeOneID.vue";
import EmployeeCMP from "@/views/Admin/Consent/OnePlatform/EmployeeCMP.vue";
import SendOnechatDetail from "@/views/Admin/Consent/OnePlatform/SendOnePlatformDetail.vue";
import SendBotOnePlatFormDetail from "./SendBotOnePlatFormDetail.vue";
import BotOnePlatformGroupSendDetail from "./BotOnePlatformGroupSendDetail.vue";
import authorization from "@/functions/authorization.js";
import OverlaySearch from "@/components/layouts/LoadingPage.vue";

import { mapGetters } from "vuex";
export default {
  components: {
    EmployeeOneID,
    EmployeeCMP,
    SendOnechatDetail,
    SendBotOnePlatFormDetail,
    BotOnePlatformGroupSendDetail,
    OverlaySearch,
  },
  data() {
    return {
      tab: null,
      items: [this.$t("onechat.new1")],
      tableload: false,
      isLoading: true,
      loadedChild: {
        group: false,
        detail: false,
      },
      Search: "",
      BotName: "",
      AllService: [],
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
    };
  },
  methods: {
    onChildLoaded(name) {
      this.loadedChild[name] = true;
      if (this.loadedChild.group && this.loadedChild.detail) {
        this.isLoading = false;
      }
    },
    // Add any methods you need here
    Fn_Detail(item) {
      // this.$router.push({ path: "/qrcode-detail" });
    },
    Fn_BackIndex() {
      this.$router.push("/bot-index");
    },
    async Fn_GetDetailBotOnePlatform() {
      var biz_id = this.$cookies.get("BusinessId");
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var auth = await authorization.encodeDataNew(Headers);
      this.axios
        .get(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            `onechat/GroupSend/${this._ฺBotOnePlatformID}/Details`,
          {
            headers: {
              Authorization: "Bearer " + auth,
              "ngrok-skip-browser-warning": "true",
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          this.tableload = false;
        })
        .catch((error) => {
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
          this.tableload = false;
        });
    },
  },
  computed: {
    ...mapGetters(["DataBotOnePlatform"]),
    _ฺBotOnePlatformAll: {
      get() {
        return this.DataBotOnePlatform || "-";
      },
    },
    _ฺBotOnePlatformID: {
      get() {
        return this.DataBotOnePlatform.Id || "-";
      },
    },
    _ฺBotOnePlatformQrcodeName: {
      get() {
        return this.DataBotOnePlatform.GroupName || "รายละเอียด";
      },
    },
    headers() {
      return [
        {
          text: "ชื่อ QR Code",
          align: "center",
          value: "QrcodeName",
          width: "20%",
          sortable: false,
        },
        {
          text: "ประเภท",
          value: "Type",
          align: "center",
          width: "20%",
          sortable: false,
        },
        {
          text: this.$i18n.t("mcg.row3"),
          align: "center",
          value: "NameTh",
          width: "20%",
          sortable: false,
        },
        {
          text: this.$i18n.t("onechat.date"),
          align: "center",
          value: "UpdatdeAt",
          width: "20%",
          sortable: false,
        },
        {
          text: this.$i18n.t("policyForm.select"),
          value: "action",
          sortable: false,
          width: "20%",
          align: "center",
        },
      ];
    },
  },
  mounted() {},
};
</script>

<style></style>
